import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  Button,
  InputGroup,
  Dropdown,
  DropdownButton,
  Form,
  Accordion,
  Tabs,
  Tab,
  Row,
  Col,
  ListGroup,
} from "react-bootstrap";
import { RichTextEditor } from "../../../Components";
import {
  GLOBAL_FILE_UPLOAD_URL,
  SETTING_FORM_URL,
  VIEW_DROPDOWN_URL,
  VIEW_KEYVALUE_URL,
  CREATE_FORM_URL,
  FORM_BUILDER_MAP_FILLED_URL,
  FORM_BUILDER_TO_DATA_SOURCE,
  FORM_BUILDER_AUTOSEARCH_LIST_URL,
  CREATE_FORM_URL_LATEST,
  FORM_BUILDER_GLOBAL,
} from "../../../Constant/api";
import { authService } from "../../../Service/Axios";
import {
  DEFAULT_MODULE_TYPE,
  DOCUMENT_TYPE_PDF_ONLY,
  FORMBUILDER_FILE_TYPES,
  IMAGE_TYPES,
  NON_DOCUMENT_TYPES,
} from "../../../Constant/constants";
import { toast } from "react-toastify";
import { VideoRecorder } from "../Admin/ApplicationStatus/Chat/VideoRecorder";

const FormRightbar = ({
  openset,
  rcvData,
  settingData,
  availQid,
  settings,
  setsettings,
  dynamicDd,
  rcvForm,
  dataForm,
  page,
}) => {
  const { t } = useTranslation();

  const { formId } = useParams();

  const [seqNo, setseqNo] = useState(settingData?.sequenceNo);
  const [question, setquestion] = useState(settingData?.label);
  const [mandatory, setmandatory] = useState(settingData?.editfield?.required);
  const [field, setfield] = useState(settingData?.editfield?.questionName);
  const [sectionDescription, setSectionDescription] = useState(
    settingData?.editfield?.sectionDescription
  );
  const [paragraph, setParagraph] = useState(settingData?.editfield?.paragraph);
  const [placehold, setplacehold] = useState(
    settingData?.editfield?.placeholderText
  );
  const [videoUrl, setvideoUrl] = useState(settingData?.videoURL);
  const [imgUrl, setimgUrl] = useState(settingData?.imageURL);
  const [rateStar, setrateStar] = useState(settingData?.ratingNo);
  const [gridOneChoiceRowBool, setgridOneChoiceRowBool] = useState(settingData?.gridOneChoiceRow);
  const [gridOneChoiceColumnBool, setgridOneChoiceColumnBool] = useState(settingData?.gridOneChoiceColumn);
  const [gridMultiChoceRowBool, setgridMultiChoceRowBool] = useState(settingData?.gridMultiChoceRow);
  const [descrip, setdescrip] = useState(
    settingData?.editfield?.fieldDescription
  );
  const [colsel, setcolsel] = useState(settingData?.editfield?.columnSpan);
  const [hiden, sethiden] = useState(settingData?.editfield?.hidden);
  const [intrnl, setintrnl] = useState(settingData?.editfield?.internal);
  const [unq, setunq] = useState(settingData?.editfield?.uniqueValue);
  const [dropval, setdropval] = useState("");
  const [dropkey, setdropkey] = useState("");
  const [droparr, setdroparr] = useState(
    settingData?.editfield?.dropdownValues
  );
  const [Type, setType] = useState(settingData?.elementType);
  const [questionID, setquestionID] = useState(settingData?.questionId);
  const [dropList, setdropList] = useState([]);
  const [showDown, setshowDown] = useState(false);
  const [dropDownSel, setdropDownSel] = useState("");
  const [togle, settogle] = useState(
    settingData?.editfield?.parentQuestionName.length > 0
  );
  const [dynamo, setdynamo] = useState(
    settingData?.editfield?.parentQuestionName
  );
  const [dynamicArr, setdynamicArr] = useState(
    dynamicDd.filter((i) => {
      return i.label == dynamo;
    })[0]?.dropdownValues
  );
  const [searchVal, setsearchVal] = useState("");
  const [parentEle, setparentEle] = useState([]);
  const [fileInput, setfileInput] = useState("");
  const [uploadCheck, setuploadCheck] = useState(
    settingData?.editfield?.fileuploadtypes
  );
  const [minLength, setminLength] = useState(
    settingData?.validateField?.minimumLength
  );
  const [maxLength, setmaxLength] = useState(
    settingData?.validateField?.maximumLength
  );
  const [charType, setcharType] = useState(
    settingData?.validateField?.charcterTypeValue
  );
  const [numberCheck, setnumberCheck] = useState(
    settingData?.validateField?.numericValue[0]
  );
  const [NegNum, setNegNum] = useState(
    settingData?.validateField?.negativeNumber
  );
  const [valide, setvalide] = useState(settingData?.validateField?.validation);

  const [calc, setcalc] = useState(settingData?.calculate);
  const [calcType, setcalcType] = useState(settingData?.calculateType);
  const [calcValueType, setcalcValueType] = useState(
    settingData?.calculateValueType
  );
  const [calcValue, setcalcValue] = useState(settingData?.calculation);
  const [calExps, setcalExps] = useState(settingData?.calculation?.expersion);
  const [calcOps, setcalcOps] = useState(settingData?.calculation?.operators);
  const [calcFilds, setcalcFilds] = useState(
    settingData?.calculation?.operands
  );

  useEffect(() => {
    setcalcValue({
      expersion: calExps,
      operators: calcOps,
      operands: calcFilds,
    });
  }, [calExps, calcOps, calcFilds]);

  const [rul, setrul] = useState(settingData?.addrule);
  const [sow, setsow] = useState(settingData?.show);
  const a = Math.floor(100000 + Math.random() * 900000);
  const b = Math.floor(100000 + Math.random() * 900000);
  const [logConditn, setlogConditn] = useState(
    settingData?.mainConditions?.length > 0
      ? settingData?.mainConditions
      : [
        {
          condition: "AND",
          id: a,
          if: "",
          questions: [
            {
              name: "",
              operator: "",
              id: b,
              values: [],
            },
          ],
        },
      ]
  );
  const oho = [];
  if (settingData?.mainConditions?.length > 0) {
    settingData?.mainConditions?.forEach((i) =>
      i.questions?.forEach((item) => {
        if (
          dynamicDd.filter((i) => {
            return i.questionName == item.name;
          })[0]?.typename == "toggle_on"
        )
          oho.push({
            ID: item.id,
            NAME: item.name,
            PRO: [{ value: "Yes" }, { value: "No" }],
          });
        else
          oho.push({
            ID: item.id,
            NAME: item.name,
            PRO: dynamicDd.filter((i) => {
              return i.questionName == item.name;
            })[0]?.dropdownValues,
          });
      })
    );
  }
  const [optParent, setoptParent] = useState(
    settingData?.mainConditions[0]?.if?.length > 0 ? oho : []
  );

  // start
  const [calulateOthersdropDownSel, setcalulateOthersdropDownSel] = useState("");
  const [calulateOthersdroparr, setcalulateOthersdroparr] = useState(
    settingData?.calulateOthersMultiSelect
  );
  const [calulateOtherVal, setcalulateOtherVal] = useState(
    settingData?.calulateOthersValue
  );
  const handleSavDropsetcalulateOthers = (e) => {
    e.preventDefault();
    setcalulateOthersdroparr([
      ...calulateOthersdroparr,
      {
        key: dropkey,
        value: dropval,
        check: false,
      },
    ]);
    setdropkey("");
    setdropval("");
  };
  const getDropDowncalulateOthers = async () => {
    const payload = { name: calulateOthersdropDownSel };
    const response = await authService(VIEW_KEYVALUE_URL, "POST", payload);
    if (response) {
      setcalulateOthersdroparr(response);
    }
  };

  useEffect(() => {
    if (calulateOthersdropDownSel.length > 0) getDropDowncalulateOthers();
  }, [calulateOthersdropDownSel]);

  const acalulateOthers = Math.floor(100000 + Math.random() * 900000);
  const bcalulateOthers = Math.floor(100000 + Math.random() * 900000);
  const [calulateOtherslogConditn, setcalulateOtherslogConditn] = useState(
    settingData?.calulateOthersCond?.length > 0
      ? settingData?.calulateOthersCond
      : [
        {
          condition: "AND",
          id: acalulateOthers,
          if: "",
          questions: [
            {
              name: "",
              operator: "",
              id: bcalulateOthers,
              values: [],
            },
          ],
        },
      ]
  );
  const calulateOthersoho = [];
  if (settingData?.calulateOthersCond?.length > 0) {
    settingData?.calulateOthersCond?.forEach((i) =>
      i.questions?.forEach((item) => {
        if (
          dynamicDd.filter((i) => {
            return i.questionName == item.name;
          })[0]?.typename == "toggle_on"
        )
          calulateOthersoho.push({
            ID: item.id,
            NAME: item.name,
            PRO: [{ value: "Yes" }, { value: "No" }],
          });
        else
          calulateOthersoho.push({
            ID: item.id,
            NAME: item.name,
            PRO: dynamicDd.filter((i) => {
              return i.questionName == item.name;
            })[0]?.dropdownValues,
          });
      })
    );
  }
  const [calulateOthersoptParent, setcalulateOthersoptParent] = useState(
    settingData?.calulateOthersCond[0]?.if?.length > 0 ? calulateOthersoho : []
  );

  const handleSelParentcalulateOthers = (e, x, data) => {
    setcalulateOtherslogConditn(
      calulateOtherslogConditn.map((item) => {
        if (item.id == data[0]) {
          return {
            ...item,
            questions: item.questions.map((i) => {
              if (i.id == x.id) {
                return { ...i, name: e.target.value };
              }
              return i;
            }),
          };
        }
        return item;
      })
    );

    if (
      dynamicDd.filter((i) => {
        return i.questionName == e.target.value;
      })[0]?.typename == "toggle_on"
    ) {
      setcalulateOthersoptParent([
        ...calulateOthersoptParent,
        {
          ID: x.id,
          NAME: e.target.value,
          PRO: [{ value: "Yes" }, { value: "No" }],
        },
      ]);
    } else {
      setcalulateOthersoptParent([
        ...calulateOthersoptParent,
        {
          ID: x.id,
          NAME: e.target.value,
          PRO: dynamicDd.filter((i) => {
            return i.questionName == e.target.value;
          })[0]?.dropdownValues,
        },
      ]);
    }
  };

  const [calulateOthersvalDd, setcalulateOthersValDd] = useState("");

  const handleParentSearchcalulateOthers = (e, data, extra) => {
    setcalulateOthersValDd(e.target.value);
    if (
      dynamicDd.filter((i) => {
        return i.questionName == data;
      })[0]?.typename == "toggle_on"
    )
      setcalulateOthersoptParent([
        ...calulateOthersoptParent,
        {
          ID: extra,
          NAME: data,
          PRO: [{ value: "Yes" }, { value: "No" }],
        },
      ]);
    else
      setcalulateOthersoptParent([
        ...calulateOthersoptParent,
        {
          ID: extra,
          NAME: data,
          PRO: dynamicDd.filter((i) => {
            return i.questionName == data;
          })[0]?.dropdownValues,
        },
      ]);
  };

  const handleParentChangecalulateOthers = (e, data, val, ele, nam) => {
    data?.includes(e.target.value)
      ? setcalulateOtherslogConditn(
        calulateOtherslogConditn.map((item) => {
          if (item.id == val) {
            return {
              ...item,
              questions: item.questions.map((i) => {
                if (i.name == nam) {
                  let x = data.filter((itm) =>
                    calulateOthersoptParent
                      ?.filter((i) => i.NAME == nam)[0]
                      ?.PRO.map((i) => i.value)
                      .includes(itm)
                  );
                  return {
                    ...i,
                    values: x.filter((item) => item != e.target.value),
                  };
                }
                return i;
              }),
            };
          }
          return item;
        })
      )
      : setcalulateOtherslogConditn(
        calulateOtherslogConditn.map((item) => {
          if (item.id == val) {
            return {
              ...item,
              questions: item.questions.map((i) => {
                if (i.name == nam) {
                  let x = data.filter((itm) =>
                    calulateOthersoptParent
                      ?.filter((i) => i.NAME == nam)[0]
                      ?.PRO.map((i) => i.value)
                      .includes(itm)
                  );
                  return { ...i, values: [...x, e.target.value] };
                }
                return i;
              }),
            };
          }
          return item;
        })
      );
  };

  const handleDelDropcalulateOthers = (sel) => {
    setcalulateOthersdroparr(calulateOthersdroparr.filter((i) => i.key != sel));
  };
  // end

  const [mapFilled, setmapFilled] = useState([]);

  const mapFilledAction = async () => {
    const payload = {};
    const response = await authService(
      FORM_BUILDER_MAP_FILLED_URL,
      "POST",
      payload
    );
    if (response) {
      setmapFilled(response);
    }
  };

  const [mapVal, setmapVal] = useState(settingData?.editfield?.objectmap);

  const [toDataSource, settoDataSource] = useState([]);

  const toDataSourceAction = async (mapVal) => {
    const payload = { gid: mapVal };
    const response = await authService(
      FORM_BUILDER_TO_DATA_SOURCE,
      "POST",
      payload
    );
    if (response) {
      settoDataSource(response);
    }
  };

  const [toVal, settoVal] = useState(settingData?.editfield?.fieldmap);

  const [boolMapping, setboolMapping] = useState(
    settingData?.editfield?.mapping
  );

  const [manuallyAuto, setmanuallyAuto] = useState("");
  const [importAuto, setimportAuto] = useState("");

  const [autoList, setautoList] = useState([]);

  const [showAuto, setshowAuto] = useState(false);

  const [autoSel, setautoSel] = useState(settingData?.editfield?.autoSearch);

  const [boolautoSearchEvent, setboolautoSearchEvent] = useState(
    settingData?.editfield?.autoSearchEvent
  );

  const [autoKey, setautoKey] = useState(settingData?.editfield?.autoSearchKey);

  const [checkIt, setCheckIt] = useState(false);

  const [glbflag, setGlbflag] = useState(false);

  const [videoRecorderModal, setVideoRecorderModal] = useState(false);

  const [commentVideoList, setCommentVideoList] = useState([]);

  const [rowMulti, setRowMulti] = useState(settingData?.editfield?.gridRows);

  const [colMulti, setColMulti] = useState(settingData?.editfield?.gridColumns);

  const [row, setRow] = useState("");

  const [col, setCol] = useState("");

  useEffect(() => {
    mapFilledAction();
    if (mapVal.length > 0) toDataSourceAction(mapVal);
    setboolMapping(mapVal.length > 0 && toVal.length > 0);
  }, [mapVal, toVal]);

  useEffect(() => {
    rcvData({
      question,
      mandatory,
      field,
      placehold,
      descrip,
      sectionDescription,
      paragraph,
      colsel,
      hiden,
      intrnl,
      droparr,
      Type,
      questionID,
      dynamo,
      uploadCheck,
      maxLength,
      minLength,
      charType,
      numberCheck,
      NegNum,
      rul,
      sow,
      logConditn,
      valide,
      boolMapping,
      mapVal,
      toVal,
      autoSel,
      boolautoSearchEvent,
      unq,
      autoKey,
      calc,
      calcValue,
      calcValueType,
      calcType,
      calulateOtherslogConditn,
      calulateOthersdroparr,
      calulateOtherVal,
      videoUrl,
      imgUrl,
      rateStar,
      gridOneChoiceRowBool,
      gridOneChoiceColumnBool,
      gridMultiChoceRowBool,
      glbflag,
      rowMulti,
      colMulti,
    });
  }, [
    question,
    mandatory,
    field,
    placehold,
    descrip,
    sectionDescription,
    paragraph,
    colsel,
    hiden,
    intrnl,
    droparr,
    Type,
    dynamo,
    uploadCheck,
    maxLength,
    minLength,
    charType,
    numberCheck,
    NegNum,
    rul,
    sow,
    logConditn,
    valide,
    boolMapping,
    mapVal,
    toVal,
    autoSel,
    boolautoSearchEvent,
    unq,
    autoKey,
    calc,
    calcValue,
    calcValueType,
    calcType,
    calulateOtherslogConditn,
    calulateOthersdroparr,
    calulateOtherVal,
    videoUrl,
    imgUrl,
    rateStar,
    gridOneChoiceRowBool,
    gridOneChoiceColumnBool,
    gridMultiChoceRowBool,
    glbflag,
    rowMulti,
    colMulti
  ]);

  const handleSavDrop = (e) => {
    e.preventDefault();
    toast.success("Saved!");
    setdroparr([
      ...droparr,
      {
        key: dropkey,
        value: dropval,
        parentkey: parentEle,
      },
    ]);
    setdropkey("");
    setdropval("");
  };

  const handleDelDrop = (sel) => {
    setdroparr(droparr.filter((i) => i.key != sel));
  };

  const settingFormAction = async () => {
    const payload = {
      elementType: Type?.length > 0 ? Type : openset,
      questionId: questionID,
      formId: parseInt(availQid),
      sectionId: dynamicDd.filter((i) => i.questionId == questionID)[0]
        ?.sectionId,
      label: question,
      sequenceNo: seqNo,
      editfield: {
        questionName: field,
        placeholderText: placehold,
        fieldDescription: descrip,
        required: mandatory,
        hidden: hiden,
        internal: intrnl,
        columnSpan: parseInt(colsel),
        parentQuestionName: dynamo,
        dropdownValues: droparr,
        fileuploadtypes: uploadCheck,
        mapping: boolMapping,
        objectmap: mapVal,
        fieldmap: toVal,
        sectionDescription,
        paragraph: paragraph,
        autoSearch: autoSel,
        autoSearchEvent: boolautoSearchEvent,
        uniqueValue: unq,
        autoSearchKey: autoKey,
        gridRows: rowMulti,
        gridColumns: colMulti,
      },
      validateField: {
        fieldLength: false,
        minimumLength: minLength,
        maximumLength: maxLength,
        charcterType: false,
        charcterTypeValue: charType,
        patternType: false,
        patternTypeValue: "",
        numericType: false,
        numericValue: numberCheck,
        numberRange: false,
        numberRangeValue: "",
        measurement: false,
        measurementValue: "",
        negativeNumber: NegNum,
        validation: valide,
      },
      globalField: glbflag,
      globalId: Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000,
      addrule: rul,
      show: sow,
      mainConditions: logConditn,
      calculate: calc,
      calculateType: calcType,
      calculateValueType: calcValueType,
      calculation: calcValue,
      calulateOthersCond: calulateOtherslogConditn,
      calulateOthersMultiSelect: calulateOthersdroparr,
      calulateOthersValue: calulateOtherVal,
      videoURL: videoUrl,
      imageURL: imgUrl,
      ratingNo: rateStar,
      gridOneChoiceRow: gridOneChoiceRowBool,
      gridOneChoiceColumn: gridOneChoiceColumnBool,
      gridMultiChoceRow: gridMultiChoceRowBool
    };
    const response = await authService(SETTING_FORM_URL, "POST", payload);
    if (response) {
      toast.success("Saved Setting!");
      setType(response.elementType);
      setsettings(false);
    }
  };

  const createFormAction = async (data) => {
    const payload = {
      formId: formId,
      formName: "",
      description: "",
      status: data,
      pages: page?.map((elem) => {
        return {
          ...elem,
          questions: dataForm
        };
      }),
    };

    const response = await authService(CREATE_FORM_URL_LATEST, "POST", payload);
    if (response) {
      rcvForm(response);
    }
  };

  const handleSaveSetting = () => {
    if (field.length > 0 && question.length > 0) {
      settingFormAction();
      setTimeout(() => {
        createFormAction("save");
      }, 3000);
    } else {
      toast.error("Both 'Add Question Here' & 'Field Name' are mandatory!");
    }
  };

  const handleAutoComplete = async () => {
    const payload = {};
    const response = await authService(
      FORM_BUILDER_AUTOSEARCH_LIST_URL,
      "POST",
      payload
    );
    if (response) {
      setautoList(response);
    }
    setshowAuto(!showAuto);
  };

  const handleDropdownList = async () => {
    const payload = {};
    const response = await authService(VIEW_DROPDOWN_URL, "POST", payload);
    if (response) {
      setdropList(response);
    }
    setshowDown(!showDown);
  };

  const getDropDown = async () => {
    const payload = { name: dropDownSel };
    const response = await authService(VIEW_KEYVALUE_URL, "POST", payload);
    if (response) {
      setdroparr(response);
    }
  };

  useEffect(() => {
    if (dropDownSel.length > 0) getDropDown();
  }, [dropDownSel]);

  useEffect(() => {
    if (glbflag) {
      handleSaveSetting()
      setGlbflag(false)
    }
  }, [glbflag])

  const handleAutoComp = (e) => {
    setautoKey(e.target.value);
  };

  const handleDynamo = (e) => {
    setdynamo(e.target.value);

    if (
      dynamicDd.filter((i) => {
        return i.label == e.target.value;
      })[0]?.typename == "toggle_on"
    )
      setdynamicArr([{ value: "Yes" }, { value: "No" }]);
    else
      setdynamicArr(
        dynamicDd.filter((i) => {
          return i.label == e.target.value;
        })[0]?.dropdownValues
      );
  };

  const handleSelParent = (e, x, data) => {
    setlogConditn(
      logConditn.map((item) => {
        if (item.id == data[0]) {
          return {
            ...item,
            questions: item.questions.map((i) => {
              if (i.id == x.id) {
                return { ...i, name: e.target.value };
              }
              return i;
            }),
          };
        }
        return item;
      })
    );

    if (
      dynamicDd.filter((i) => {
        return i.questionName == e.target.value;
      })[0]?.typename == "toggle_on"
    ) {
      setoptParent([
        ...optParent,
        {
          ID: x.id,
          NAME: e.target.value,
          PRO: [{ value: "Yes" }, { value: "No" }],
        },
      ]);
    } else {
      setoptParent([
        ...optParent,
        {
          ID: x.id,
          NAME: e.target.value,
          PRO: dynamicDd.filter((i) => {
            return i.questionName == e.target.value;
          })[0]?.dropdownValues,
        },
      ]);
    }
  };

  const handleDynSearch = (e) => {
    setsearchVal(e.target.value);

    if (e.target.value.length > 0)
      setdynamicArr(
        dynamicArr?.filter((i) => {
          return i.value.toLowerCase().includes(e.target.value.toLowerCase());
        })
      );
    else if (
      dynamicDd.filter((i) => {
        return i.label == dynamo;
      })[0]?.typename == "toggle_on"
    )
      setdynamicArr([{ value: "Yes" }, { value: "No" }]);
    else
      setdynamicArr(
        dynamicDd.filter((i) => {
          return i.label == dynamo;
        })[0]?.dropdownValues
      );
  };

  const [valDd, setValDd] = useState("");

  const handleParentSearch = (e, data, extra) => {
    setValDd(e.target.value);
    if (
      dynamicDd.filter((i) => {
        return i.questionName == data;
      })[0]?.typename == "toggle_on"
    )
      setoptParent([
        ...optParent,
        {
          ID: extra,
          NAME: data,
          PRO: [{ value: "Yes" }, { value: "No" }],
        },
      ]);
    else
      setoptParent([
        ...optParent,
        {
          ID: extra,
          NAME: data,
          PRO: dynamicDd.filter((i) => {
            return i.questionName == data;
          })[0]?.dropdownValues,
        },
      ]);
  };

  const handleinpChange = (e) => {
    parentEle?.includes(e.target.value)
      ? setparentEle(parentEle.filter((item) => item != e.target.value))
      : setparentEle([...parentEle, e.target.value]);
  };

  const handleParentChange = (e, data, val, ele, nam) => {
    data?.includes(e.target.value)
      ? setlogConditn(
        logConditn.map((item) => {
          if (item.id == val) {
            return {
              ...item,
              questions: item.questions.map((i) => {
                if (i.name == nam) {
                  let x = data.filter((itm) =>
                    optParent
                      ?.filter((i) => i.NAME == nam)[0]
                      ?.PRO.map((i) => i.value)
                      .includes(itm)
                  );
                  return {
                    ...i,
                    values: x.filter((item) => item != e.target.value),
                  };
                }
                return i;
              }),
            };
          }
          return item;
        })
      )
      : setlogConditn(
        logConditn.map((item) => {
          if (item.id == val) {
            return {
              ...item,
              questions: item.questions.map((i) => {
                if (i.name == nam) {
                  let x = data.filter((itm) =>
                    optParent
                      ?.filter((i) => i.NAME == nam)[0]
                      ?.PRO.map((i) => i.value)
                      .includes(itm)
                  );
                  return { ...i, values: [...x, e.target.value] };
                }
                return i;
              }),
            };
          }
          return item;
        })
      );
  };

  const handleFileChange = (e) => {
    setfileInput(e.target.files[0]);
  };

  const uploadFile = async (file) => {
    const fileParts = file.type.split("/");
    const fileType = fileParts[1];

    let fileSize = 0;
    if (FORMBUILDER_FILE_TYPES.includes(fileType)) {
      if (file.size < 1000000) {
        fileSize = Math.floor(file.size / 1000) + "KB";
      } else {
        fileSize = Math.floor(file.size / 1000000) + "MB";
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("appType", DEFAULT_MODULE_TYPE.formBuilder);
      const response = await authService(
        GLOBAL_FILE_UPLOAD_URL,
        "POST",
        formData
      );
      if (response) {
        toast.success("Saved!");
        if (Type?.length > 0 ? Type == "image" : openset == "image") {
          setimgUrl(response.url)
        }
        else {
          setdroparr((prev) => [
            ...prev,
            {
              key: response.url,
              value: response.name,
              parentkey: [
                response.size < 1000000
                  ? Math.floor(response.size / 1000) + "KB"
                  : Math.floor(response.size / 1000000) + "MB",
              ],
            },
          ])
        }
      }
    }
  };

  const handleUpChange = (e) => {
    uploadCheck?.includes(e.target.value)
      ? setuploadCheck(uploadCheck.filter((item) => item != e.target.value))
      : setuploadCheck([...uploadCheck, e.target.value]);
  };

  const handleNumber = (e) => {
    setnumberCheck([e.target.value])
    // numberCheck?.includes(e.target.value)
    //   ? setnumberCheck(numberCheck.filter((item) => item != e.target.value))
    //   : setnumberCheck([...numberCheck, e.target.value]);
  };

  const handleLogic = (e) => {
    setlogConditn([
      ...logConditn,
      {
        condition: "AND",
        id: Math.floor(100000 + Math.random() * 900000),
        if: "ALL",
        questions: [
          {
            name: "",
            operator: "",
            id: Math.floor(100000 + Math.random() * 900000),
            values: [],
          },
        ],
      },
    ]);
  };

  const handleChangeParagraphText = (value) => {
    setParagraph(value);
  };

  const toggleVideoRecorderModal = () => {
    setVideoRecorderModal(!videoRecorderModal);
  };

  const handleUploadVideo = async (url) => {
    setCommentVideoList((prev) => [...prev, url]);
    setvideoUrl(url);
  };

  const handleRemoveVideo = async (url) => {
    // Remove the video URL from the list
    const updatedVideoList = commentVideoList.filter((video) => video !== url);
    setvideoUrl(url);
    // Update the state with the new video list
    setCommentVideoList(updatedVideoList);
  };

  const handleRemoveRow = (sel) => {
    setRowMulti(rowMulti.filter((i) => i != sel));
  };

  const handleRemoveCol = (sel) => {
    setColMulti(colMulti.filter((i) => i != sel));
  };

  return (
    <>
      <div className="formeditor-sidebar ms-auto sidebar-right bg-white global-tab h-100">
        <div className="p-3 h-100 d-flex flex-column row-gap-3">
          <Tabs defaultActiveKey="edit-filed" id="uncontrolled-tab-example">
            <Tab eventKey="edit-filed" title="Edit field">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>GENERAL SETTING</Accordion.Header>
                  <Accordion.Body>
                    {(Type?.length > 0
                      ? Type != "pgbreak"
                      : openset != "pgbreak") && (
                        <div className="mb-3 input-sm">
                          {(
                            Type?.length > 0
                              ? Type != "sectn"
                              : openset != "sectn"
                          ) ? (
                            <label htmlFor="fieldName" className="form-label">
                              Add Question Here
                            </label>
                          ) : (
                            <label htmlFor="fieldName" className="form-label">
                              Add Section Header
                            </label>
                          )}
                          {(
                            Type?.length > 0
                              ? Type == "confirms"
                              : openset == "confirms"
                          ) ? (
                            <textarea
                              className="form-control"
                              id="placeholderText"
                              rows="3"
                              onChange={(e) => {
                                setquestion(e.target.value);
                              }}
                              value={question}
                            ></textarea>
                          ) : (
                            <input
                              type="text"
                              className="form-control"
                              id="fieldName"
                              placeholder="Add Text"
                              onChange={(e) => {
                                setquestion(e.target.value);
                              }}
                              value={question}
                            />
                          )}
                        </div>
                      )}

                    <hr />
                    <div className="mb-3 input-sm">
                      <label htmlFor="fieldName" className="form-label">
                        {(
                          Type?.length > 0
                            ? Type != "sectn"
                            : openset != "sectn"
                        )
                          ? "Field Name "
                          : "Section Name "}
                        <small>(This should be unique)</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fieldName"
                        placeholder={
                          (
                            Type?.length > 0
                              ? Type != "sectn"
                              : openset != "sectn"
                          )
                            ? "Field Name "
                            : "Section Name "
                        }
                        onChange={(e) => {
                          setfield(e.target.value);
                        }}
                        value={field}
                      />
                    </div>
                    <hr />
                    {Type?.length > 0 && Type === "sectn" ? (
                      // && openset === "sectn"
                      <div className="mb-3 input-sm">
                        <label
                          htmlFor="placeholderReason"
                          className="form-label"
                        >
                          Add Section Description
                        </label>
                        <textarea
                          className="form-control"
                          id="placeholderReason"
                          rows="3"
                          placeholder="Section Description"
                          onChange={(e) => {
                            setSectionDescription(e.target.value);
                          }}
                          value={sectionDescription}
                        ></textarea>
                      </div>
                    ) : null}

                    {Type?.length > 0 && Type === "paragraph" ? (
                      <div className="mb-3 input-sm">
                        <label htmlFor="fieldName" className="form-label">
                          Text Editor
                        </label>
                        <RichTextEditor
                          value={paragraph}
                          onChange={handleChangeParagraphText}
                        />
                      </div>
                    ) : null}

                    {(Type?.length > 0
                      ? Type == "confirms"
                      : openset == "confirms") && (
                        <>
                          <div className="mb-3 input-sm">
                            <label htmlFor="columnSpan" className="form-label">
                              Column Span
                            </label>
                            <select
                              className="form-select"
                              id="columnSpan"
                              aria-label="Default select example"
                              value={colsel}
                              onChange={(e) => {
                                setcolsel(e.target.value);
                              }}
                            >
                              <option value="1">1</option>
                              <option value="2">2</option>
                            </select>
                          </div>
                          <hr />
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckDefault"
                              >
                                Required Field
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                onChange={(e) => {
                                  setmandatory(e.target.checked);
                                }}
                                checked={mandatory}
                              />
                            </div>
                          </div>
                          <hr />
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckDefault"
                              >
                                Read Ony Field
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                onChange={(e) => {
                                  sethiden(e.target.checked);
                                }}
                                checked={hiden}
                              />
                            </div>
                          </div>
                          <hr />
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckDefault"
                              >
                                Internal Field
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                onChange={(e) => {
                                  setintrnl(e.target.checked);
                                }}
                                checked={intrnl}
                              />
                            </div>
                          </div>
                        </>
                      )}

                    {(Type?.length > 0
                      ? Type == "auto_complete"
                      : openset == "auto_complete") && (
                        <>
                          <hr />
                          <div className="mb-3 input-sm">
                            <label htmlFor="fieldName" className="form-label">
                              Auto complete Options
                            </label>

                            <div className="d-flex">
                              <div className="col">
                                <Dropdown
                                  className="d-grid gap-2 max-230"
                                  autoClose="outside"
                                  align={{ lg: "end" }}
                                >
                                  <Dropdown.Toggle
                                    variant="gray-light border rounded-start-0 plus-btn"
                                    id="dropdown-basic"
                                  >
                                    {autoSel}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <div className="px-2">
                                      <div className="d-grid gap-2">
                                        <Dropdown
                                          className="d-grid gap-2 max-230"
                                          autoClose="outside"
                                          align={{ lg: "end" }}
                                        >
                                          <Dropdown.Toggle
                                            variant="gray-light"
                                            id="dropdown-basic"
                                            onClick={handleAutoComplete}
                                          >
                                            Import from database
                                          </Dropdown.Toggle>

                                          {showAuto && (
                                            <div className="item py-2">
                                              <select
                                                className="form-select"
                                                id="columnSpan"
                                                aria-label="Default select example"
                                                value={autoList.find(
                                                  (i) => i == autoSel
                                                )}
                                                onChange={(e) => {
                                                  setautoSel(e.target.value);
                                                  setimportAuto(e.target.value);
                                                }}
                                              >
                                                <option></option>
                                                {autoList?.map((item) => {
                                                  return (
                                                    <option value={item}>
                                                      {item}
                                                    </option>
                                                  );
                                                })}
                                              </select>
                                            </div>
                                          )}
                                        </Dropdown>
                                        <Dropdown
                                          className="d-grid gap-2 add-option"
                                          autoClose="outside"
                                          align={{ lg: "end" }}
                                        >
                                          <Dropdown.Toggle
                                            variant="dark plus-btn"
                                            id="dropdown-basic"
                                          >
                                            Add manually
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <div className="py-2 px-3">
                                              <div className="d-flex mb-3">
                                                <div className="col">
                                                  <Form.Label htmlFor="inputKey">
                                                    Value
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    id="inputKey"
                                                    aria-describedby="passwordHelpBlock"
                                                    className="rounded-start-0"
                                                    onChange={(e) => {
                                                      setmanuallyAuto(
                                                        e.target.value
                                                      );
                                                    }}
                                                    value={manuallyAuto}
                                                  />
                                                </div>
                                              </div>
                                              <div className="gap-4">
                                                <Button
                                                  variant="gray-light me-2"
                                                  onClick={(e) => {
                                                    setmanuallyAuto("");
                                                  }}
                                                >
                                                  {t("common.button.cancel")}
                                                </Button>

                                                <Button
                                                  variant="dark"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    setautoSel(manuallyAuto);
                                                  }}
                                                >
                                                  Save
                                                </Button>
                                              </div>
                                            </div>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="parent-filed"
                              >
                                Auto Search Event
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="parent-filed"
                                onChange={(e) => {
                                  setboolautoSearchEvent(e.target.checked);
                                }}
                                checked={boolautoSearchEvent}
                              />
                            </div>
                          </div>
                        </>
                      )}

                    {((Type?.length > 0
                      ? Type == "drop_on"
                      : openset == "drop_on") ||
                      (Type?.length > 0
                        ? Type == "check_on"
                        : openset == "check_on") ||
                      (Type?.length > 0
                        ? Type == "multiChecks"
                        : openset == "multiChecks") ||
                      (Type?.length > 0
                        ? Type == "mutiple_on"
                        : openset == "mutiple_on")) && (
                        <>
                          <hr />
                          <div className="mb-3 input-sm">
                            {(Type?.length > 0
                              ? Type == "drop_on"
                              : openset == "drop_on") && (
                                <label htmlFor="fieldName" className="form-label">
                                  Dropdown Options
                                </label>
                              )}

                            {(Type?.length > 0
                              ? Type == "check_on"
                              : openset == "check_on") && (
                                <label htmlFor="fieldName" className="form-label">
                                  Checkbox Options
                                </label>
                              )}

                            {(Type?.length > 0
                              ? Type == "multiChecks"
                              : openset == "multiChecks") && (
                                <label htmlFor="fieldName" className="form-label">
                                  Multi Checkbox Options
                                </label>
                              )}

                            {(Type?.length > 0
                              ? Type == "mutiple_on"
                              : openset == "mutiple_on") && (
                                <label htmlFor="fieldName" className="form-label">
                                  Radio Button Options
                                </label>
                              )}

                            <div className="d-flex">
                              <div className="col-2">
                                <Dropdown
                                  className="d-grid edit-option"
                                  autoClose="outside"
                                >
                                  <Dropdown.Toggle
                                    variant="gray-light border border-end-0 rounded-end-0"
                                    id="dropdown-basic"
                                  ></Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <div className="py-0 px-3">
                                      <Accordion
                                        defaultActiveKey="0"
                                        className="option-accordion relative"
                                      >
                                        {droparr?.map((item, index) => {
                                          return (
                                            <Accordion.Item
                                              eventKey={index}
                                              className="relative"
                                            >
                                              <Accordion.Header>
                                                {item.value}
                                              </Accordion.Header>
                                              <div className="edit-dlt-btn">
                                                <Button
                                                  variant="transparent"
                                                  onClick={(e) =>
                                                    handleDelDrop(item.key)
                                                  }
                                                >
                                                  <i className="bx bx-trash-alt"></i>
                                                </Button>
                                              </div>
                                              <Accordion.Body className="pb-0">
                                                <ul className="m-0 p-0">
                                                  <li>
                                                    <strong>Value :</strong>{" "}
                                                    {item.value}
                                                  </li>
                                                  <li>
                                                    <strong>Key :</strong>{" "}
                                                    {item.key}
                                                  </li>
                                                  <li>
                                                    <strong>Parent :</strong>{" "}
                                                    {item.parentkey?.map((i) => (
                                                      <span>{"{" + i + "}"}</span>
                                                    ))}
                                                  </li>
                                                </ul>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          );
                                        })}
                                      </Accordion>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                              <div className="col">
                                <Dropdown
                                  className="d-grid gap-2 max-230"
                                  autoClose="outside"
                                  align={{ lg: "end" }}
                                >
                                  <Dropdown.Toggle
                                    variant="gray-light border rounded-start-0 plus-btn"
                                    id="dropdown-basic"
                                  >
                                    Add Options
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <div className="px-2">
                                      <div className="d-grid gap-2">
                                        <Dropdown
                                          className="d-grid gap-2 max-230"
                                          autoClose="outside"
                                          align={{ lg: "end" }}
                                        >
                                          <Dropdown.Toggle
                                            variant="gray-light"
                                            id="dropdown-basic"
                                            onClick={handleDropdownList}
                                          >
                                            Import from database
                                          </Dropdown.Toggle>

                                          {showDown && (
                                            <div className="item py-2">
                                              <select
                                                className="form-select"
                                                id="columnSpan"
                                                aria-label="Default select example"
                                                value={dropDownSel}
                                                onChange={(e) => {
                                                  setdropDownSel(e.target.value);
                                                }}
                                              >
                                                <option></option>
                                                {dropList?.map((item) => {
                                                  return (
                                                    <option value={item}>
                                                      {item}
                                                    </option>
                                                  );
                                                })}
                                              </select>
                                            </div>
                                          )}
                                        </Dropdown>
                                        <Dropdown
                                          className="d-grid gap-2 add-option"
                                          autoClose="outside"
                                          align={{ lg: "end" }}
                                        >
                                          <Dropdown.Toggle
                                            variant="dark plus-btn"
                                            id="dropdown-basic"
                                          >
                                            Add manually
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <div className="py-2 px-3">
                                              <div className="d-flex mb-3">
                                                <div className="col">
                                                  <Form.Label htmlFor="inputValue">
                                                    Key
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    id="inputValue"
                                                    aria-describedby="passwordHelpBlock"
                                                    className="rounded-end-0 border-end-0"
                                                    onChange={(e) => {
                                                      setdropkey(e.target.value);
                                                    }}
                                                    value={dropkey}
                                                  />
                                                </div>
                                                <div className="col">
                                                  <Form.Label htmlFor="inputKey">
                                                    Value
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    id="inputKey"
                                                    aria-describedby="passwordHelpBlock"
                                                    className="rounded-start-0"
                                                    onChange={(e) => {
                                                      setdropval(e.target.value);
                                                    }}
                                                    value={dropval}
                                                  />
                                                </div>
                                                <div className="col-2">
                                                  <Form.Label htmlFor="parentKey">
                                                    Parent
                                                  </Form.Label>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="light btn-xs rounded-start-0 w-100 border-bottom-0"
                                                      id="dropdown-basic"
                                                    ></Dropdown.Toggle>

                                                    <Dropdown.Menu className="p-3">
                                                      <div className="select-group">
                                                        <div className="selected-options">
                                                          <input
                                                            className="search-input"
                                                            placeholder="Search"
                                                            type="text"
                                                            onChange={
                                                              handleDynSearch
                                                            }
                                                          />
                                                        </div>
                                                        <ListGroup className="select-dropdown">
                                                          {dynamicArr?.map(
                                                            (i) => {
                                                              return (
                                                                <ListGroup.Item>
                                                                  <label>
                                                                    <input
                                                                      type="checkbox"
                                                                      className="form-check-input me-2"
                                                                      value={
                                                                        i.value
                                                                      }
                                                                      checked={parentEle?.includes(
                                                                        i.value
                                                                      )}
                                                                      onChange={
                                                                        handleinpChange
                                                                      }
                                                                    />
                                                                    {i.value}
                                                                  </label>
                                                                </ListGroup.Item>
                                                              );
                                                            }
                                                          )}
                                                        </ListGroup>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </div>
                                              </div>
                                              <div className="gap-4">
                                                <Button
                                                  variant="gray-light me-2"
                                                  onClick={(e) => {
                                                    setdropkey("");
                                                    setdropval("");
                                                  }}
                                                >
                                                  {t("common.button.cancel")}
                                                </Button>

                                                <Button
                                                  variant="dark"
                                                  onClick={handleSavDrop}
                                                >
                                                  Save
                                                </Button>
                                              </div>
                                            </div>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="parent-filed"
                              >
                                Dependent on Parent field
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="parent-filed"
                                onChange={(e) => {
                                  settogle(e.target.checked);
                                }}
                                checked={togle}
                              />
                            </div>
                          </div>
                          {togle && (
                            <div className="mb-3 input-sm">
                              <label htmlFor="columnSpan" className="form-label">
                                Choose Parent field
                              </label>
                              <select
                                className="form-select"
                                id="columnSpan"
                                aria-label="Default select example"
                                value={dynamo}
                                onChange={handleDynamo}
                              >
                                <option></option>
                                {dynamicDd
                                  .filter((i) => {
                                    return (
                                      (i.typename == "drop_on" &&
                                        i.sequenceNo < seqNo) ||
                                      (i.typename == "mutiple_on" &&
                                        i.sequenceNo < seqNo) ||
                                      (i.typename == "toggle_on" &&
                                        i.sequenceNo < seqNo) ||
                                      (i.typename == "check_on" &&
                                        i.sequenceNo < seqNo) ||
                                      (i.typename == "multiChecks" &&
                                        i.sequenceNo < seqNo)
                                    );
                                  })
                                  .map((item) => {
                                    return (
                                      <option value={item.label}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          )}
                          <hr />
                        </>
                      )}

                    {((Type?.length > 0
                      ? Type == "short"
                      : openset == "short") ||
                      (Type?.length > 0 ? Type == "long" : openset == "long") ||
                      (Type?.length > 0
                        ? Type == "number"
                        : openset == "number") ||
                      (Type?.length > 0
                        ? Type == "drop_on"
                        : openset == "drop_on") ||
                      (Type?.length > 0
                        ? Type == "description"
                        : openset == "description") ||
                      (Type?.length > 0
                        ? Type == "emails"
                        : openset == "emails")) && (
                        <>
                          <div className="mb-3 input-sm">
                            <label
                              htmlFor="placeholderText"
                              className="form-label"
                            >
                              Placeholder text
                            </label>
                            <textarea
                              className="form-control"
                              id="placeholderText"
                              rows="3"
                              onChange={(e) => {
                                setplacehold(e.target.value);
                              }}
                              value={placehold}
                            ></textarea>
                          </div>
                          <hr />
                        </>
                      )}

                    {((Type?.length > 0
                      ? Type == "fileDown"
                      : openset == "fileDown") ||
                      (Type?.length > 0 ? Type == "image" : openset == "image")) && (
                        <>
                          <div className="mb-3 input-sm">
                            <label htmlFor="fieldName" className="form-label">
                              Upload File
                            </label>
                            <div className="d-flex">
                              {(Type?.length > 0
                                ? Type == "fileDown"
                                : openset == "fileDown") && <div className="col-2">
                                  <Dropdown
                                    className="d-grid edit-option"
                                    autoClose="outside"
                                  >
                                    <Dropdown.Toggle
                                      variant="gray-light border border-end-0 rounded-end-0"
                                      id="dropdown-basic"
                                    ></Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <div className="py-0 px-3">
                                        <Accordion
                                          defaultActiveKey="0"
                                          className="option-accordion relative"
                                        >
                                          {droparr?.map((item, index) => {
                                            return (
                                              <Accordion.Item
                                                eventKey={index}
                                                className="relative"
                                              >
                                                <Accordion.Header>
                                                  {item.value}
                                                </Accordion.Header>
                                                <div className="edit-dlt-btn">
                                                  <Button
                                                    variant="transparent"
                                                    onClick={(e) =>
                                                      handleDelDrop(item.key)
                                                    }
                                                  >
                                                    <i className="bx bx-trash-alt"></i>
                                                  </Button>
                                                </div>
                                                <Accordion.Body className="pb-0">
                                                  <ul className="m-0 p-0">
                                                    <li>
                                                      <strong>File Size : </strong>
                                                      {item.parentkey[0]}
                                                    </li>
                                                  </ul>
                                                </Accordion.Body>
                                              </Accordion.Item>
                                            );
                                          })}
                                        </Accordion>
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>}
                              <div className="col">
                                <Dropdown
                                  className="d-grid gap-2 add-option"
                                  autoClose="outside"
                                  align={{ lg: "end" }}
                                >
                                  <Dropdown.Toggle
                                    variant="gray-light border rounded-start-0 plus-btn"
                                    id="dropdown-basic"
                                  >
                                    {(Type?.length > 0
                                      ? Type == "fileDown"
                                      : openset == "fileDown") ? "Add Files" :
                                      imgUrl.split("/")[imgUrl.split("/").length - 1]}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <div className="py-2 px-3">
                                      <div className="d-flex">
                                        <div className="col">
                                          <Form.Group
                                            controlId="formFile"
                                            className="mb-3"
                                          >
                                            <Form.Label>
                                              Select file input{" "}
                                            </Form.Label>
                                            <Form.Control
                                              type="file"
                                              className="rounded-start-0"
                                              onChange={handleFileChange}
                                            />
                                          </Form.Group>
                                        </div>
                                      </div>
                                      <div className="gap-4">
                                        <Button
                                          variant="gray-light me-2"
                                          onClick={() => ""}
                                        >
                                          {t("common.button.cancel")}
                                        </Button>
                                        <Button
                                          variant="dark"
                                          onClick={() => uploadFile(fileInput)}
                                        >
                                          {t("common.button.save")}
                                        </Button>
                                      </div>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                          <hr />
                        </>
                      )}

                    {(Type?.length > 0 ? Type == "multiinp" : openset == "multiinp") &&
                      <div className="mb-3 input-sm grid-">
                        <label for="fieldName" className="form-label">
                          Multi Grid Options
                        </label>
                        <Dropdown
                          className="w-100 "
                          autoClose="outside"
                          align={{ lg: "end" }}
                        >
                          <Dropdown.Toggle
                            variant="gray-light border down-btn w-100 plus-btn"
                            id="dropdown-basic"
                          >
                            Add Row details
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="grid-option-dropdown position-relative">
                            <div className="px-3 pb-3">
                              {
                                rowMulti?.map((item, index) => {
                                  return <div>
                                    <p>{item}</p>
                                    <Button
                                      variant="transparent small-btn position-absolute row-delete-btn"
                                      size="sm"
                                      onClick={() => handleRemoveRow(item)}
                                    >
                                      <span className="material-symbols-outlined align-middle remove-btn">
                                        delete
                                      </span>
                                    </Button>
                                  </div>
                                })
                              }
                              <label for="fieldName" className="form-label">
                                Row Name{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="fieldName"
                                placeholder="Row 1"
                                value={row}
                                onChange={(e) => setRow(e.target.value)}
                              />
                              <hr className="my-1" />
                              <div className="mt-2">
                                <Button variant="gray-light me-2" onClick={() => setRow("")}>
                                  {t("common.button.cancel")}
                                </Button>
                                <Button variant="dark" onClick={() => { setRowMulti([...rowMulti, row]); setRow("") }}>Save</Button>
                              </div>

                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                        <hr />
                        <Dropdown
                          className="w-100 "
                          autoClose="outside"
                          align={{ lg: "end" }}
                        >
                          <Dropdown.Toggle
                            variant="gray-light border down-btn w-100 plus-btn"
                            id="dropdown-basic"
                          >
                            Add Column details
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="grid-option-dropdown position-relative">
                            <div className="px-3 pb-3">
                              {
                                colMulti?.map((item, index) => {
                                  return <div>
                                    <p>{item}</p>
                                    <Button
                                      variant="transparent small-btn position-absolute row-delete-btn"
                                      size="sm"
                                      onClick={() => handleRemoveCol(item)}
                                    >
                                      <span className="material-symbols-outlined align-middle remove-btn">
                                        delete
                                      </span>
                                    </Button>
                                  </div>
                                })
                              }
                              <label for="fieldName" className="form-label">
                                Column Name{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="fieldName"
                                placeholder="Column 1"
                                value={col}
                                onChange={(e) => setCol(e.target.value)}
                              />
                              <hr className="my-1" />
                              <div className="mt-2">
                                <Button variant="gray-light me-2" onClick={() => setCol("")}>
                                  {t("common.button.cancel")}
                                </Button>
                                <Button variant="dark" onClick={() => { setColMulti([...colMulti, col]); setCol("") }}>Save</Button>
                              </div>

                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                        <hr />
                      </div>
                    }

                    {(Type?.length > 0
                      ? Type == "video"
                      : openset == "video")
                      && (
                        <>
                          <div className="mb-3 input-sm">
                            <label htmlFor="fieldName" className="form-label">
                              Add Video Link
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="fieldName"
                              placeholder="Enter video url"
                              onChange={(e) => {
                                setvideoUrl(e.target.value);
                              }}
                              value={videoUrl}
                            />
                            <div className="editor-tools-bar flex-wrap">
                              <div className="editor-tools-icons">
                                <ul>
                                  <li>
                                    <button type="button" onClick={toggleVideoRecorderModal}>
                                      <i className="bx bx-video"></i>
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {/* {commentVideoList?.length > 0 &&
                            commentVideoList.map((video, index) => (
                              <span
                                className="video-format d-flex align-items-center p-1 position-relative"
                                key={index.toString()}
                              >
                                <button
                                  className="w-5 h-5 d-flex justify-content-center align-items-center rounded-circle text-white border-2 border-solid border-slate-50 bg-slate-600 position-absolute z-1 video-close-btn"
                                  onClick={() => handleRemoveVideo(video)}
                                >
                                  <i className="bx bx-x"></i>
                                </button>

                                <a
                                  className="w-8 h-8 bx-md d-flex justify-content-center align-items-center text-white border-0 bg-transparent position-absolute video-play-btn z-2"
                                  // onClick={() => handlePlayVideo(video)}
                                  href={video}
                                  target="_blank"
                                >
                                  <i className="bx bx-play"></i>
                                </a>
                                <video
                                  className="video-player"
                                  src={video}
                                  controls
                                ></video>
                              </span>
                            ))} */}
                          </div>
                          <hr />
                        </>
                      )
                    }

                    {(Type?.length > 0
                      ? Type == "fileUp"
                      : openset == "fileUp") && (
                        <>
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label className="form-check-label" htmlFor="file-type">
                                Allowed File Type
                              </label>
                            </div>

                            <Form>
                              {["checkbox"].map((type) => (
                                <div key={`file-type-${type}`} className="mb-3">
                                  <Form.Check
                                    label="JPG"
                                    type={type}
                                    id={`file-type-${type}`}
                                    value={"jpeg"}
                                    checked={uploadCheck?.includes("jpeg")}
                                    onChange={handleUpChange}
                                  />
                                  <Form.Check
                                    label="PNG"
                                    type={type}
                                    id={`file-type-${type}`}
                                    value={"png"}
                                    checked={uploadCheck?.includes("png")}
                                    onChange={handleUpChange}
                                  />
                                  <Form.Check
                                    label="PDF"
                                    type={type}
                                    id={`file-type-${type}`}
                                    value={"pdf"}
                                    checked={uploadCheck?.includes("pdf")}
                                    onChange={handleUpChange}
                                  />
                                  <Form.Check
                                    label="DOC"
                                    type={type}
                                    id={`file-type-${type}`}
                                    value={
                                      "vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    }
                                    checked={uploadCheck?.includes(
                                      "vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    )}
                                    onChange={handleUpChange}
                                  />
                                </div>
                              ))}
                            </Form>
                          </div>
                          <hr />
                        </>
                      )}

                    {(Type?.length > 0
                      ? Type != "sectn"
                      : openset != "sectn") &&
                      (Type?.length > 0
                        ? Type != "pgbreak"
                        : openset != "pgbreak") &&
                      (Type?.length > 0
                        ? Type != "confirms"
                        : openset != "confirms") && (
                        <>
                          <div className="mb-3 input-sm">
                            <label
                              htmlFor="placeholderReason"
                              className="form-label"
                            >
                              Field Instruction
                            </label>
                            <textarea
                              className="form-control"
                              id="placeholderReason"
                              rows="3"
                              placeholder="Add Text"
                              onChange={(e) => {
                                setdescrip(e.target.value);
                              }}
                              value={descrip}
                            ></textarea>
                          </div>
                          <hr />
                          <div className="mb-3 input-sm">
                            <label htmlFor="columnSpan" className="form-label">
                              Column Span
                            </label>
                            <select
                              className="form-select"
                              id="columnSpan"
                              aria-label="Default select example"
                              value={colsel}
                              onChange={(e) => {
                                setcolsel(e.target.value);
                              }}
                            >
                              <option value="1">1</option>
                              <option value="2">2</option>
                            </select>
                          </div>
                          <hr />
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckDefault"
                              >
                                Required Field
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                onChange={(e) => {
                                  setmandatory(e.target.checked);
                                }}
                                checked={mandatory}
                              />
                            </div>
                          </div>
                          <hr />
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckDefault"
                              >
                                Read Ony Field
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                onChange={(e) => {
                                  sethiden(e.target.checked);
                                }}
                                checked={hiden}
                              />
                            </div>
                          </div>
                          <hr />
                          <div className="mb-3 input-sm">
                            <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckDefault"
                              >
                                Internal Field
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                onChange={(e) => {
                                  setintrnl(e.target.checked);
                                }}
                                checked={intrnl}
                              />
                            </div>
                            <hr />
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Unique Value
                                </label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckDefault"
                                  onChange={(e) => {
                                    setunq(e.target.checked);
                                  }}
                                  checked={unq}
                                />
                              </div>
                            </div>
                            <hr />
                            <div className="mb-3 input-sm">
                              <label htmlFor="columnSpan" className="form-label">
                                AutoComplete dependent field
                              </label>
                              <select
                                className="form-select"
                                id="columnSpan"
                                aria-label="Default select example"
                                value={autoKey}
                                onChange={handleAutoComp}
                              >
                                <option></option>
                                {dynamicDd
                                  .filter((i) => {
                                    return (
                                      i.typename == "auto_complete" &&
                                      i.sequenceNo < seqNo
                                    );
                                  })
                                  .map((item) => {
                                    return (
                                      <option value={item.label}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          </div>

                          <div className="mb-3 border rounded-3">
                            <Accordion defaultActiveKey="0">
                              <Accordion.Item
                                eventKey="0"
                                className="bg-transparent border-bottom"
                              >
                                <Accordion.Header className="px-2">
                                  Map field
                                </Accordion.Header>
                                <Accordion.Body className="px-2">
                                  <div className="mb-3">
                                    <div className="mb-3 input-sm switch-row position-relative">
                                      <div className="row">
                                        <div className="col">
                                          <label
                                            htmlFor="fieldType"
                                            className="form-label"
                                          >
                                            Map field
                                          </label>
                                          <select
                                            className="form-select"
                                            id="fieldType"
                                            aria-label="Default select example"
                                            value={mapVal}
                                            onChange={(e) => {
                                              setmapVal(e.target.value);
                                            }}
                                          >
                                            <option></option>
                                            {mapFilled?.map((item) => (
                                              <option value={item.gid}>
                                                {item.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <div className="col">
                                          <label
                                            htmlFor="fieldType"
                                            className="form-label text-orange-900"
                                          >
                                            To Data Source
                                          </label>
                                          <select
                                            className="form-select"
                                            id="fieldType"
                                            aria-label="Default select example"
                                            value={toVal}
                                            onChange={(e) => {
                                              settoVal(e.target.value);
                                            }}
                                          >
                                            <option></option>
                                            {toDataSource?.map((item) => (
                                              <option value={item.questionId}>
                                                {item.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </div>

                          {(Type?.length > 0
                            ? Type != "sectn"
                            : openset != "sectn") &&
                            (Type?.length > 0
                              ? Type != "pgbreak"
                              : openset != "pgbreak") &&
                            (Type?.length > 0
                              ? Type != "confirms"
                              : openset != "confirms") &&
                            (Type?.length > 0
                              ? Type != "drop_on"
                              : openset != "drop_on") &&
                            (Type?.length > 0
                              ? Type != "toggle_on"
                              : openset != "toggle_on") &&
                            (Type?.length > 0
                              ? Type != "check_on"
                              : openset != "check_on") &&
                            (Type?.length > 0
                              ? Type != "multiChecks"
                              : openset != "multiChecks") &&
                            (Type?.length > 0
                              ? Type != "mutiple_on"
                              : openset != "mutiple_on") &&
                            (Type?.length > 0
                              ? Type != "fileUp"
                              : openset != "fileUp") &&
                            (Type?.length > 0
                              ? Type != "fileDown"
                              : openset != "fileDown") &&
                            (Type?.length > 0
                              ? Type != "confirms"
                              : openset != "confirms") &&
                            (Type?.length > 0
                              ? Type != "emails"
                              : openset != "emails") && (
                              <div className="mb-3 input-sm">
                                <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexSwitchCheckDefault"
                                  >
                                    Validate Field
                                  </label>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckDefault"
                                    onChange={(e) => {
                                      setvalide(e.target.checked);
                                    }}
                                    checked={valide}
                                  />
                                </div>
                              </div>
                            )}
                        </>
                      )}
                  </Accordion.Body>
                </Accordion.Item>

                {valide && (
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>VALIDATE FIELD</Accordion.Header>
                    <Accordion.Body>
                      {(Type?.length > 0
                        ? Type != "dates"
                        : openset != "dates") &&
                        (Type?.length > 0
                          ? Type != "times"
                          : openset != "times") && (
                          <>
                            <div className="input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Field Length
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <div className="row">
                                <div className="col">
                                  <label htmlFor="fieldType" className="form-label">
                                    Min Length
                                  </label>
                                  <select
                                    className="form-select"
                                    id="fieldType"
                                    aria-label="Default select example"
                                    value={minLength}
                                    onChange={(e) => {
                                      setminLength(e.target.value);
                                    }}
                                  >
                                    <option value="">select</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                  </select>
                                </div>
                                <div className="col">
                                  <label htmlFor="fieldType" className="form-label">
                                    Max Length
                                  </label>
                                  <select
                                    className="form-select"
                                    id="fieldType"
                                    aria-label="Default select example"
                                    value={maxLength}
                                    onChange={(e) => {
                                      setmaxLength(e.target.value);
                                    }}
                                  >
                                    <option value="">select</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      {(Type?.length > 0
                        ? Type != "dates"
                        : openset != "dates") &&
                        (Type?.length > 0
                          ? Type != "times"
                          : openset != "times") &&
                        (Type?.length > 0
                          ? Type != "number"
                          : openset != "number") && (
                          <>
                            <hr />
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Character Type
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <select
                                className="form-select"
                                id="fieldType"
                                aria-label="Default select example"
                                value={charType}
                                onChange={(e) => {
                                  setcharType(e.target.value);
                                }}
                              >
                                <option></option>
                                <option value="Alphabet">Alphabet</option>
                                <option value="Alphanumeric">
                                  Alphanumeric
                                </option>
                                {/* <option value="Numeric">Numeric</option> */}
                              </select>
                            </div>
                          </>
                        )}
                      {(Type?.length > 0
                        ? Type != "dates"
                        : openset != "dates") &&
                        (Type?.length > 0
                          ? Type != "times"
                          : openset != "times") &&
                        (Type?.length > 0
                          ? Type == "number"
                          : openset == "number") && (
                          <>
                            <hr />
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Numeric Type
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <Form>
                                {["radio"].map((type) => (
                                  <div key={`reverse-${type}`} className="mb-3">
                                    <Form.Check
                                      label="Integer Value"
                                      name="group1"
                                      type={type}
                                      id={`reverse-${type}-1`}
                                      value={"integer"}
                                      checked={numberCheck?.includes("integer")}
                                      onChange={handleNumber}
                                    />
                                    <Form.Check
                                      label="Decimal Value"
                                      name="group2"
                                      type={type}
                                      id={`reverse-${type}-2`}
                                      value={"decimal"}
                                      checked={numberCheck?.includes("decimal")}
                                      onChange={handleNumber}
                                    />
                                  </div>
                                ))}
                              </Form>
                            </div>
                            <hr />
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Negative Number
                                </label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckDefault"
                                  onChange={(e) => {
                                    setNegNum(e.target.checked);
                                  }}
                                  checked={NegNum}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      {(Type?.length > 0
                        ? Type == "times"
                        : openset == "times") && (
                          <>
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Allowed Time Frame
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <div className="row">
                                <div className="col">
                                  <label htmlFor="fieldType" className="form-label">
                                    Start form
                                  </label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    id="fieldName"
                                    placeholder="Choose date"
                                    value={charType}
                                    onChange={(e) => {
                                      setcharType(e.target.value);
                                    }}
                                  />
                                </div>
                                <div className="col">
                                  <label htmlFor="fieldType" className="form-label">
                                    End at
                                  </label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    id="fieldName"
                                    placeholder="Choose date"
                                    value={numberCheck && numberCheck[0]}
                                    onChange={(e) => {
                                      setnumberCheck([e.target.value]);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Time Format
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <Form.Select
                                aria-label="Default select example"
                                value={placehold}
                                onChange={(e) => {
                                  setplacehold(e.target.value);
                                }}
                              >
                                <option></option>
                                <option value="12">12 hr</option>
                                <option value="24">24 hr</option>
                              </Form.Select>
                            </div>
                          </>
                        )}
                      {(Type?.length > 0
                        ? Type == "dates"
                        : openset == "dates") && (
                          <>
                            <div className="mt-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Allowed Calender Dates
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Start form
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <input
                                type="date"
                                className="form-control"
                                id="fieldName"
                                placeholder="Choose date"
                                value={charType}
                                onChange={(e) => {
                                  setcharType(e.target.value);
                                }}
                              />
                            </div>
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  End at
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <input
                                type="date"
                                className="form-control"
                                id="fieldName"
                                placeholder="Choose date"
                                value={numberCheck && numberCheck[0]}
                                onChange={(e) => {
                                  setnumberCheck([e.target.value]);
                                }}
                              />
                            </div>
                            <hr />
                            <hr />
                            <div className="mb-3 input-sm">
                              <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Date Format
                                </label>
                              </div>
                            </div>
                            <div className="mb-3 input-sm">
                              <Form.Select
                                aria-label="Default select example"
                                value={placehold}
                                onChange={(e) => {
                                  setplacehold(e.target.value);
                                }}
                              >
                                <option></option>
                                <option value="DD-MM-YYYY">DD-MM-YYYY</option>
                                <option value="MM-DD-YYYY">MM-DD-YYYY</option>
                                <option value="YYYY-DD-MM">YYYY-DD-MM</option>
                                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                              </Form.Select>
                            </div>
                          </>
                        )}
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
            </Tab>
            <Tab eventKey="logic" title="Logic">
              <div className="email-form form-body pe-1">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="mb-3 input-sm">
                      <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                        <label className="form-check-label" htmlFor="parent-filed">
                          Add Rule
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="parent-filed"
                          onChange={(e) => {
                            setrul(e.target.checked);
                          }}
                          checked={rul}
                        />
                      </div>
                    </div>
                  </div>

                  {rul && (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="mb-3 input-sm">
                        <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                          <label
                            className="form-check-label"
                            htmlFor="parent-filed"
                          >
                            Show
                          </label>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="parent-filed"
                            onChange={(e) => {
                              setsow(e.target.checked);
                            }}
                            checked={sow}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {rul &&
                  logConditn?.map((item, index, arr) => (
                    <div className="if-wrapper">
                      <div className="step-row mb-4">
                        <div className="d-flex">
                          <div className="d-flex justify-content-between align-items-center">
                            <label>If</label>
                          </div>
                          {index > 0 && (
                            <button
                              type="button"
                              className="delete-btn"
                              onClick={() =>
                                setlogConditn(
                                  logConditn.filter((i) => i.id != item.id)
                                )
                              }
                            >
                              <i className="bx bx-x"></i>
                            </button>
                          )}
                        </div>
                        <div className="row align-items-center">
                          {index > 0 && (
                            <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                              <div className="mb-3">
                                <select
                                  className="form-select"
                                  value={item.condition}
                                  onChange={(e) =>
                                    setlogConditn(
                                      logConditn.map((i) => {
                                        if (i.id == item.id) {
                                          return {
                                            ...i,
                                            condition: e.target.value,
                                          };
                                        }
                                        return i;
                                      })
                                    )
                                  }
                                >
                                  <option value="AND">AND</option>
                                  <option value="OR">OR</option>
                                </select>
                              </div>
                            </div>
                          )}
                          <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                            <div className="mb-3">
                              <select
                                className="form-select"
                                value={item.if}
                                onChange={(e) =>
                                  setlogConditn(
                                    logConditn.map((i) => {
                                      if (i.id == item.id) {
                                        return {
                                          ...i,
                                          if: e.target.value,
                                        };
                                      }
                                      return i;
                                    })
                                  )
                                }
                              >
                                <option></option>
                                <option value="All">All</option>
                                <option value="Any">Any</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-7 col-md-5 col-sm-6 col-12">
                            <div className="mb-3">
                              <strong className="small">
                                of the following is true
                              </strong>
                            </div>
                          </div>
                        </div>

                        {item.questions?.map(
                          function (ele, index, arr) {
                            return (
                              <div className="add-row-wrapper">
                                <div className="row">
                                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="mb-3">
                                      <select
                                        className="form-select"
                                        value={ele.name}
                                        onChange={(e) =>
                                          handleSelParent(e, ele, this)
                                        }
                                      >
                                        <option></option>
                                        {dynamicDd
                                          .filter((i) => {
                                            let x = i.sectionId;
                                            return (
                                              (i.typename == "drop_on" &&
                                                (i.sequenceNo < seqNo ||
                                                  dataForm.filter(
                                                    (it) => it.sectionId == x
                                                  )[0]?.rules <
                                                  dataForm.filter(
                                                    (it) =>
                                                      it.sectionId ==
                                                      settingData.questionId
                                                  )[0]?.rules)) ||
                                              (i.typename == "mutiple_on" &&
                                                (i.sequenceNo < seqNo ||
                                                  dataForm.filter(
                                                    (it) => it.sectionId == x
                                                  )[0]?.rules <
                                                  dataForm.filter(
                                                    (it) =>
                                                      it.sectionId ==
                                                      settingData.questionId
                                                  )[0]?.rules)) ||
                                              (i.typename == "toggle_on" &&
                                                (i.sequenceNo < seqNo ||
                                                  dataForm.filter(
                                                    (it) => it.sectionId == x
                                                  )[0]?.rules <
                                                  dataForm.filter(
                                                    (it) =>
                                                      it.sectionId ==
                                                      settingData.questionId
                                                  )[0]?.rules)) ||
                                              (i.typename == "check_on" &&
                                                (i.sequenceNo < seqNo ||
                                                  dataForm.filter(
                                                    (it) => it.sectionId == x
                                                  )[0]?.rules <
                                                  dataForm.filter(
                                                    (it) =>
                                                      it.sectionId ==
                                                      settingData.questionId
                                                  )[0]?.rules)) ||
                                              (i.typename == "multiChecks" &&
                                                (i.sequenceNo < seqNo ||
                                                  dataForm.filter(
                                                    (it) => it.sectionId == x
                                                  )[0]?.rules <
                                                  dataForm.filter(
                                                    (it) =>
                                                      it.sectionId ==
                                                      settingData.questionId
                                                  )[0]?.rules))
                                            );
                                          })
                                          .map((item) => {
                                            return (
                                              <option value={item.questionName}>
                                                {item.questionName}
                                              </option>
                                            );
                                          })}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="mb-3">
                                      <select
                                        className="form-select"
                                        value={ele.operator}
                                        onChange={(e) =>
                                          setlogConditn(
                                            logConditn.map((item) => {
                                              if (item.id == this[0]) {
                                                return {
                                                  ...item,
                                                  questions: item.questions.map(
                                                    (i) => {
                                                      if (i.id == ele.id) {
                                                        return {
                                                          ...i,
                                                          operator:
                                                            e.target.value,
                                                        };
                                                      }
                                                      return i;
                                                    }
                                                  ),
                                                };
                                              }
                                              return item;
                                            })
                                          )
                                        }
                                      >
                                        <option></option>
                                        <option value="equals">equals</option>
                                        <option value="not equals">
                                          not equals
                                        </option>
                                        <option value="in this list">
                                          in this list
                                        </option>
                                        <option value="not in this list">
                                          not in this list
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="select-group">
                                      <div className="selected-options">
                                        <input
                                          className="search-input"
                                          placeholder="Search"
                                          type="text"
                                          onChange={(e) =>
                                            handleParentSearch(
                                              e,
                                              ele.name,
                                              ele.id
                                            )
                                          }
                                        />
                                      </div>
                                      <ListGroup className="select-dropdown">
                                        <ListGroup.Item>
                                          <label>
                                            <input
                                              type="checkbox"
                                              className="form-check-input me-2"
                                              value="Select all"
                                              checked={checkIt}
                                              onChange={(e) => {
                                                if (checkIt)
                                                  setlogConditn(
                                                    logConditn.map((item) => {
                                                      if (item.id == this[0]) {
                                                        return {
                                                          ...item,
                                                          questions:
                                                            item.questions.map(
                                                              (i) => {
                                                                if (
                                                                  i.name ==
                                                                  ele.name
                                                                ) {
                                                                  return {
                                                                    ...i,
                                                                    values: [],
                                                                  };
                                                                }
                                                                return i;
                                                              }
                                                            ),
                                                        };
                                                      }
                                                      return item;
                                                    })
                                                  );
                                                else
                                                  setlogConditn(
                                                    logConditn.map((item) => {
                                                      if (item.id == this[0]) {
                                                        return {
                                                          ...item,
                                                          questions:
                                                            item.questions.map(
                                                              (i) => {
                                                                if (
                                                                  i.name ==
                                                                  ele.name
                                                                ) {
                                                                  return {
                                                                    ...i,
                                                                    values:
                                                                      optParent
                                                                        .filter(
                                                                          (
                                                                            item
                                                                          ) =>
                                                                            item.NAME ==
                                                                            ele.name
                                                                        )[0]
                                                                        ?.PRO?.filter(
                                                                          (
                                                                            it
                                                                          ) =>
                                                                            valDd.length >
                                                                              0
                                                                              ? it.value
                                                                                ?.toLowerCase()
                                                                                .includes(
                                                                                  valDd.toLowerCase()
                                                                                )
                                                                              : it
                                                                                .value
                                                                                .length >
                                                                              0
                                                                        )
                                                                        ?.map(
                                                                          (i) =>
                                                                            i.value
                                                                        ),
                                                                  };
                                                                }
                                                                return i;
                                                              }
                                                            ),
                                                        };
                                                      }
                                                      return item;
                                                    })
                                                  );
                                                setCheckIt(e.target.checked);
                                              }}
                                            />
                                            Select all
                                          </label>
                                        </ListGroup.Item>
                                        {optParent
                                          .filter(
                                            (item) => item.NAME == ele.name
                                          )[0]
                                          ?.PRO?.filter((it) =>
                                            valDd.length > 0
                                              ? it.value
                                                ?.toLowerCase()
                                                .includes(valDd.toLowerCase())
                                              : it.value.length > 0
                                          )
                                          ?.map(
                                            function (i, index, arr) {
                                              return (
                                                <ListGroup.Item>
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input me-2"
                                                      value={i.value}
                                                      checked={this[0]
                                                        .filter((itm) =>
                                                          optParent
                                                            ?.filter(
                                                              (i) =>
                                                                i.NAME ==
                                                                this[3]
                                                            )[0]
                                                            ?.PRO.map(
                                                              (i) => i.value
                                                            )
                                                            .includes(itm)
                                                        )
                                                        ?.includes(i.value)}
                                                      onChange={(e) => {
                                                        setCheckIt(false);
                                                        handleParentChange(
                                                          e,
                                                          this[0],
                                                          this[1],
                                                          this[2],
                                                          this[3]
                                                        );
                                                      }}
                                                    />
                                                    {i.value}
                                                  </label>
                                                </ListGroup.Item>
                                              );
                                            },
                                            [
                                              ele.values,
                                              this[0],
                                              ele.id,
                                              ele.name,
                                            ]
                                          )}
                                      </ListGroup>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 col-md-5 col-sm-6 col-12">
                                    <div className="d-flex column-gap-2 mb-2">
                                      {index == arr.length - 1 && (
                                        <button
                                          type="button"
                                          className="delete-btn"
                                          onClick={() =>
                                            setlogConditn(
                                              logConditn.map((item) => {
                                                if (item.id == this[0]) {
                                                  return {
                                                    ...item,
                                                    questions: [
                                                      ...item.questions,
                                                      {
                                                        name: "",
                                                        operator: "",
                                                        id: Math.floor(
                                                          100000 +
                                                          Math.random() *
                                                          900000
                                                        ),
                                                        values: [],
                                                      },
                                                    ],
                                                  };
                                                }
                                                return item;
                                              })
                                            )
                                          }
                                        >
                                          <i className="bx bx-plus"></i>
                                        </button>
                                      )}

                                      {index > 0 && (
                                        <button
                                          type="button"
                                          className="delete-btn"
                                          onClick={() =>
                                            setlogConditn(
                                              logConditn.map((item) => {
                                                if (item.id == this[0]) {
                                                  return {
                                                    ...item,
                                                    questions:
                                                      item.questions.filter(
                                                        (i) => i.id != ele.id
                                                      ),
                                                  };
                                                }
                                                return item;
                                              })
                                            )
                                          }
                                        >
                                          <i className="bx bx-x"></i>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  <hr />
                                </div>
                              </div>
                            );
                          },
                          [item.id]
                        )}
                      </div>
                      <div className="bachcolor-color">
                        {index == arr.length - 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                            onClick={handleLogic}
                          >
                            And/Or <i className="bx bx-plus bx-sm"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </Tab>
            <Tab eventKey="calculate" title="Calculate">
              <div className="mb-3 input-sm">
                <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                  <label className="form-check-label" htmlFor="FieldPattern">
                    Calculate filed
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="FieldPattern"
                    onChange={(e) => {
                      setcalc(e.target.checked);
                    }}
                    checked={calc}
                  />
                </div>
              </div>
              {calc && (
                <>
                  <div className="mb-3 input-sm">
                    <label htmlFor="CalculateFiled" className="form-label">
                      Calculate filed
                    </label>
                    <select
                      className="form-select"
                      id="CalculateFiled"
                      aria-label="Default select example"
                      onChange={(e) => {
                        setcalcType(e.target.value);
                      }}
                      value={calcType}
                    >
                      <option></option>
                      <option value="Date calculation">Date calculation</option>
                      <option value="Time calculation">Time calculation</option>
                      <option value="Number calculation">
                        Number calculation
                      </option>
                      <option value="Other calculation">Other calculation</option>
                    </select>
                  </div>
                  {(calcType == "Date calculation" ||
                    calcType == "Time calculation" ||
                    calcType == "Number calculation") &&
                    <div className="mb-3 input-sm">
                      <label
                        htmlFor="CalculateFiled"
                        className="form-label text-orange-900"
                      >
                        Define equation
                      </label>
                      <div className="mb-3 border rounded-3">
                        <div className="p-2 define-box">
                          <div className="d-flex g-0 flex-wrap">
                            {calExps.split(" ")?.map((item) => {
                              return (
                                <>
                                  {item.length > 1 && (
                                    <div className="m-1">
                                      <span className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-1 text-wrap text-start w-100">
                                        {item}
                                      </span>
                                    </div>
                                  )}
                                  {item.length == 1 && (
                                    <div className="btn-small m-1">
                                      <Button
                                        variant="light"
                                        size="sm"
                                        className="px-2 py-0"
                                      >
                                        {item}
                                      </Button>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                          </div>
                        </div>
                        <div className="bg-light p-2">
                          <div className="row g-2">
                            <div className="col">
                              <select
                                className="form-select"
                                id="fieldType"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  setcalcFilds([...calcFilds, e.target.value]);
                                  setcalExps(calExps + " " + e.target.value);
                                }}
                                value={calcFilds}
                              >
                                <option></option>
                                {calcType == "Date calculation" &&
                                  <>
                                    <option value="Current">Current</option>
                                    {dynamicDd
                                      .filter((i) => {
                                        return (
                                          i.typename == "dates" &&
                                          i.sequenceNo < seqNo
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <option value={item.label}>
                                            {item.label}
                                          </option>
                                        );
                                      })}</>}
                                {calcType == "Time calculation" &&
                                  <>
                                    <option value="Current">Current</option>
                                    {dynamicDd
                                      .filter((i) => {
                                        return (
                                          i.typename == "times" &&
                                          i.sequenceNo < seqNo
                                        );
                                      })
                                      .map((item) => {
                                        return (
                                          <option value={item.label}>
                                            {item.label}
                                          </option>
                                        );
                                      })}</>}
                                {calcType == "Number calculation" &&
                                  dynamicDd
                                    .filter((i) => {
                                      return (
                                        i.typename == "number" &&
                                        i.sequenceNo < seqNo
                                      );
                                    })
                                    .map((item) => {
                                      return (
                                        <option value={item.label}>
                                          {item.label}
                                        </option>
                                      );
                                    })}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <div className="calculator">
                          <div className="calculator__keys">
                            <input
                              type="button"
                              className="calculator__key"
                              value="1"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="2"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="3"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="4"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="5"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="4"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="3"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="2"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="1"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="0"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="."
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="("
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value=")"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key calculator__key--operator"
                              value="+"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key calculator__key--operator"
                              value="-"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key calculator__key--operator"
                              value="*"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key calculator__key--operator"
                              value="/"
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key"
                              value="AC"
                              onClick={(e) => {
                                setcalExps(
                                  calExps
                                    .split(" ")
                                    .slice(0, calExps.split(" ").length - 1)
                                    .join(" ")
                                );
                              }}
                            />
                            <input
                              type="button"
                              className="calculator__key calculator__key--enter"
                              value="="
                              onClick={(e) => {
                                setcalcOps([...calcOps, e.target.value]);
                                setcalExps(calExps + " " + e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {(calcType == "Date calculation" ||
                        calcType == "Time calculation") && (
                          <div className="mb-3">
                            <label
                              htmlFor="CalculateFiled"
                              className="form-label text-orange-900"
                            >
                              Expect result in
                            </label>
                            {calcType == "Date calculation" && (
                              <select
                                className="form-select"
                                id="CalculateFiled"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  setcalcValueType(e.target.value);
                                }}
                                value={calcValueType}
                              >
                                <option></option>
                                <option value="Day">Day</option>
                                <option value="Month">Month</option>
                                <option value="Year">Year</option>
                              </select>
                            )}
                            {calcType == "Time calculation" && (
                              <select
                                className="form-select"
                                id="CalculateFiled"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  setcalcValueType(e.target.value);
                                }}
                                value={calcValueType}
                              >
                                <option></option>
                                {/* <option value="Second">Second</option> */}
                                <option value="Minute">Minute</option>
                                <option value="Hour">Hour</option>
                              </select>
                            )}
                          </div>
                        )}
                    </div>}
                  {calcType == "Other calculation" &&
                    <>
                      {calulateOtherslogConditn?.map((item, index, arr) => (
                        <div className="if-wrapper">
                          <div className="step-row mb-4">
                            <div className="d-flex">
                              <div className="d-flex justify-content-between align-items-center">
                                <label>If</label>
                              </div>
                              {index > 0 && (
                                <button
                                  type="button"
                                  className="delete-btn"
                                  onClick={() =>
                                    setcalulateOtherslogConditn(
                                      calulateOtherslogConditn.filter((i) => i.id != item.id)
                                    )
                                  }
                                >
                                  <i className="bx bx-x"></i>
                                </button>
                              )}
                            </div>
                            <div className="row align-items-center">
                              {index > 0 && (
                                <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <select
                                      className="form-select"
                                      value={item.condition}
                                      onChange={(e) =>
                                        setcalulateOtherslogConditn(
                                          calulateOtherslogConditn.map((i) => {
                                            if (i.id == item.id) {
                                              return {
                                                ...i,
                                                condition: e.target.value,
                                              };
                                            }
                                            return i;
                                          })
                                        )
                                      }
                                    >
                                      <option value="AND">AND</option>
                                      <option value="OR">OR</option>
                                    </select>
                                  </div>
                                </div>
                              )}
                              <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                                <div className="mb-3">
                                  <select
                                    className="form-select"
                                    value={item.if}
                                    onChange={(e) =>
                                      setcalulateOtherslogConditn(
                                        calulateOtherslogConditn.map((i) => {
                                          if (i.id == item.id) {
                                            return {
                                              ...i,
                                              if: e.target.value,
                                            };
                                          }
                                          return i;
                                        })
                                      )
                                    }
                                  >
                                    <option></option>
                                    <option value="All">All</option>
                                    <option value="Any">Any</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-lg-7 col-md-5 col-sm-6 col-12">
                                <div className="mb-3">
                                  <strong className="small">
                                    of the following is true
                                  </strong>
                                </div>
                              </div>
                            </div>

                            {item.questions?.map(
                              function (ele, index, arr) {
                                return (
                                  <div className="add-row-wrapper">
                                    <div className="row">
                                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="mb-3">
                                          <select
                                            className="form-select"
                                            value={ele.name}
                                            onChange={(e) =>
                                              handleSelParentcalulateOthers(e, ele, this)
                                            }
                                          >
                                            <option></option>
                                            {dynamicDd
                                              .filter((i) => {
                                                let x = i.sectionId;
                                                return (
                                                  (i.typename == "drop_on" &&
                                                    (i.sequenceNo < seqNo ||
                                                      dataForm.filter(
                                                        (it) => it.sectionId == x
                                                      )[0]?.rules <
                                                      dataForm.filter(
                                                        (it) =>
                                                          it.sectionId ==
                                                          settingData.questionId
                                                      )[0]?.rules)) ||
                                                  (i.typename == "mutiple_on" &&
                                                    (i.sequenceNo < seqNo ||
                                                      dataForm.filter(
                                                        (it) => it.sectionId == x
                                                      )[0]?.rules <
                                                      dataForm.filter(
                                                        (it) =>
                                                          it.sectionId ==
                                                          settingData.questionId
                                                      )[0]?.rules)) ||
                                                  (i.typename == "toggle_on" &&
                                                    (i.sequenceNo < seqNo ||
                                                      dataForm.filter(
                                                        (it) => it.sectionId == x
                                                      )[0]?.rules <
                                                      dataForm.filter(
                                                        (it) =>
                                                          it.sectionId ==
                                                          settingData.questionId
                                                      )[0]?.rules)) ||
                                                  (i.typename == "check_on" &&
                                                    (i.sequenceNo < seqNo ||
                                                      dataForm.filter(
                                                        (it) => it.sectionId == x
                                                      )[0]?.rules <
                                                      dataForm.filter(
                                                        (it) =>
                                                          it.sectionId ==
                                                          settingData.questionId
                                                      )[0]?.rules))
                                                  ||
                                                  (i.typename == "multiChecks" &&
                                                    (i.sequenceNo < seqNo ||
                                                      dataForm.filter(
                                                        (it) => it.sectionId == x
                                                      )[0]?.rules <
                                                      dataForm.filter(
                                                        (it) =>
                                                          it.sectionId ==
                                                          settingData.questionId
                                                      )[0]?.rules))
                                                );
                                              })
                                              .map((item) => {
                                                return (
                                                  <option value={item.questionName}>
                                                    {item.questionName}
                                                  </option>
                                                );
                                              })}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="mb-3">
                                          <select
                                            className="form-select"
                                            value={ele.operator}
                                            onChange={(e) =>
                                              setcalulateOtherslogConditn(
                                                calulateOtherslogConditn.map((item) => {
                                                  if (item.id == this[0]) {
                                                    return {
                                                      ...item,
                                                      questions: item.questions.map(
                                                        (i) => {
                                                          if (i.id == ele.id) {
                                                            return {
                                                              ...i,
                                                              operator:
                                                                e.target.value,
                                                            };
                                                          }
                                                          return i;
                                                        }
                                                      ),
                                                    };
                                                  }
                                                  return item;
                                                })
                                              )
                                            }
                                          >
                                            <option></option>
                                            <option value="equals">equals</option>
                                            <option value="not equals">
                                              not equals
                                            </option>
                                            <option value="in this list">
                                              in this list
                                            </option>
                                            <option value="not in this list">
                                              not in this list
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="select-group">
                                          <div className="selected-options">
                                            <input
                                              className="search-input"
                                              placeholder="Search"
                                              type="text"
                                              onChange={(e) =>
                                                handleParentSearchcalulateOthers(
                                                  e,
                                                  ele.name,
                                                  ele.id
                                                )
                                              }
                                            />
                                          </div>
                                          <ListGroup className="select-dropdown">
                                            <ListGroup.Item>
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input me-2"
                                                  value="Select all"
                                                  checked={checkIt}
                                                  onChange={(e) => {
                                                    if (checkIt)
                                                      setcalulateOtherslogConditn(
                                                        calulateOtherslogConditn.map((item) => {
                                                          if (item.id == this[0]) {
                                                            return {
                                                              ...item,
                                                              questions:
                                                                item.questions.map(
                                                                  (i) => {
                                                                    if (
                                                                      i.name ==
                                                                      ele.name
                                                                    ) {
                                                                      return {
                                                                        ...i,
                                                                        values: [],
                                                                      };
                                                                    }
                                                                    return i;
                                                                  }
                                                                ),
                                                            };
                                                          }
                                                          return item;
                                                        })
                                                      );
                                                    else
                                                      setcalulateOtherslogConditn(
                                                        calulateOtherslogConditn.map((item) => {
                                                          if (item.id == this[0]) {
                                                            return {
                                                              ...item,
                                                              questions:
                                                                item.questions.map(
                                                                  (i) => {
                                                                    if (
                                                                      i.name ==
                                                                      ele.name
                                                                    ) {
                                                                      return {
                                                                        ...i,
                                                                        values:
                                                                          calulateOthersoptParent
                                                                            .filter(
                                                                              (
                                                                                item
                                                                              ) =>
                                                                                item.NAME ==
                                                                                ele.name
                                                                            )[0]
                                                                            ?.PRO?.filter(
                                                                              (
                                                                                it
                                                                              ) =>
                                                                                calulateOthersvalDd.length >
                                                                                  0
                                                                                  ? it.value
                                                                                    ?.toLowerCase()
                                                                                    .includes(
                                                                                      calulateOthersvalDd.toLowerCase()
                                                                                    )
                                                                                  : it
                                                                                    .value
                                                                                    .length >
                                                                                  0
                                                                            )
                                                                            ?.map(
                                                                              (i) =>
                                                                                i.value
                                                                            ),
                                                                      };
                                                                    }
                                                                    return i;
                                                                  }
                                                                ),
                                                            };
                                                          }
                                                          return item;
                                                        })
                                                      );
                                                    setCheckIt(e.target.checked);
                                                  }}
                                                />
                                                Select all
                                              </label>
                                            </ListGroup.Item>
                                            {calulateOthersoptParent
                                              .filter(
                                                (item) => item.NAME == ele.name
                                              )[0]
                                              ?.PRO?.filter((it) =>
                                                calulateOthersvalDd.length > 0
                                                  ? it.value
                                                    ?.toLowerCase()
                                                    .includes(calulateOthersvalDd.toLowerCase())
                                                  : it.value.length > 0
                                              )
                                              ?.map(
                                                function (i, index, arr) {
                                                  return (
                                                    <ListGroup.Item>
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input me-2"
                                                          value={i.value}
                                                          checked={this[0]
                                                            .filter((itm) =>
                                                              calulateOthersoptParent
                                                                ?.filter(
                                                                  (i) =>
                                                                    i.NAME ==
                                                                    this[3]
                                                                )[0]
                                                                ?.PRO.map(
                                                                  (i) => i.value
                                                                )
                                                                .includes(itm)
                                                            )
                                                            ?.includes(i.value)}
                                                          onChange={(e) => {
                                                            setCheckIt(false);
                                                            handleParentChangecalulateOthers(
                                                              e,
                                                              this[0],
                                                              this[1],
                                                              this[2],
                                                              this[3]
                                                            );
                                                          }}
                                                        />
                                                        {i.value}
                                                      </label>
                                                    </ListGroup.Item>
                                                  );
                                                },
                                                [
                                                  ele.values,
                                                  this[0],
                                                  ele.id,
                                                  ele.name,
                                                ]
                                              )}
                                          </ListGroup>
                                        </div>
                                      </div>
                                      <div className="col-lg-12 col-md-5 col-sm-6 col-12">
                                        <div className="d-flex column-gap-2 mb-2">
                                          {index == arr.length - 1 && (
                                            <button
                                              type="button"
                                              className="delete-btn"
                                              onClick={() =>
                                                setcalulateOtherslogConditn(
                                                  calulateOtherslogConditn.map((item) => {
                                                    if (item.id == this[0]) {
                                                      return {
                                                        ...item,
                                                        questions: [
                                                          ...item.questions,
                                                          {
                                                            name: "",
                                                            operator: "",
                                                            id: Math.floor(
                                                              100000 +
                                                              Math.random() *
                                                              900000
                                                            ),
                                                            values: [],
                                                          },
                                                        ],
                                                      };
                                                    }
                                                    return item;
                                                  })
                                                )
                                              }
                                            >
                                              <i className="bx bx-plus"></i>
                                            </button>
                                          )}

                                          {index > 0 && (
                                            <button
                                              type="button"
                                              className="delete-btn"
                                              onClick={() =>
                                                setcalulateOtherslogConditn(
                                                  calulateOtherslogConditn.map((item) => {
                                                    if (item.id == this[0]) {
                                                      return {
                                                        ...item,
                                                        questions:
                                                          item.questions.filter(
                                                            (i) => i.id != ele.id
                                                          ),
                                                      };
                                                    }
                                                    return item;
                                                  })
                                                )
                                              }
                                            >
                                              <i className="bx bx-x"></i>
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                      <hr />
                                    </div>
                                  </div>
                                );
                              },
                              [item.id]
                            )}
                          </div>
                          <div className="bachcolor-color">
                            {index == arr.length - 1 && (
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                                onClick={handleLogic}
                              >
                                And/Or <i className="bx bx-plus bx-sm"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      <label htmlFor="fieldName" className="form-label mt-3">
                        Value Options
                      </label>
                      {(Type == "drop_on" ||
                        Type == "mutiple_on" ||
                        Type == "toggle_on" ||
                        Type == "check_on" ||
                        Type == "multiChecks") ?
                        <div className="d-flex mb-3">
                          <div className="col-2">
                            <Dropdown
                              className="d-grid edit-option"
                              autoClose="outside"
                            >
                              <Dropdown.Toggle
                                variant="gray-light border border-end-0 rounded-end-0"
                                id="dropdown-basic"
                              ></Dropdown.Toggle>

                              <Dropdown.Menu>
                                <div className="py-0 px-3">
                                  <Accordion
                                    defaultActiveKey="0"
                                    className="option-accordion relative"
                                  >
                                    {calulateOthersdroparr?.map((item, index) => {
                                      return (
                                        <Accordion.Item
                                          eventKey={index}
                                          className="relative"
                                        >
                                          <Accordion.Header>
                                            {item.value}
                                          </Accordion.Header>
                                          <div className="edit-dlt-btn">
                                            <Button
                                              variant="transparent"
                                              onClick={(e) =>
                                                handleDelDropcalulateOthers(item.key)
                                              }
                                            >
                                              <i className="bx bx-trash-alt"></i>
                                            </Button>
                                          </div>
                                          <Accordion.Body className="pb-0">
                                            <ul className="m-0 p-0">
                                              <li>
                                                <strong>Value :</strong>{" "}
                                                {item.value}
                                              </li>
                                              <li>
                                                <strong>Key :</strong>{" "}
                                                {item.key}
                                              </li>
                                            </ul>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      );
                                    })}
                                  </Accordion>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div className="col">
                            <Dropdown
                              className="d-grid gap-2 max-230"
                              autoClose="outside"
                              align={{ lg: "end" }}
                            >
                              <Dropdown.Toggle
                                variant="gray-light border rounded-start-0 plus-btn"
                                id="dropdown-basic"
                              >
                                Add Options
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <div className="px-2">
                                  <div className="d-grid gap-2">
                                    <Dropdown
                                      className="d-grid gap-2 max-230"
                                      autoClose="outside"
                                      align={{ lg: "end" }}
                                    >
                                      <Dropdown.Toggle
                                        variant="gray-light"
                                        id="dropdown-basic"
                                        onClick={handleDropdownList}
                                      >
                                        Import from database
                                      </Dropdown.Toggle>

                                      {showDown && (
                                        <div className="item py-2">
                                          <select
                                            className="form-select"
                                            id="columnSpan"
                                            aria-label="Default select example"
                                            value={calulateOthersdropDownSel}
                                            onChange={(e) => {
                                              setcalulateOthersdropDownSel(e.target.value);
                                            }}
                                          >
                                            <option></option>
                                            {dropList?.map((item) => {
                                              return (
                                                <option value={item}>
                                                  {item}
                                                </option>
                                              );
                                            })}
                                          </select>
                                        </div>
                                      )}
                                    </Dropdown>
                                    <Dropdown
                                      className="d-grid gap-2 add-option"
                                      autoClose="outside"
                                      align={{ lg: "end" }}
                                    >
                                      <Dropdown.Toggle
                                        variant="dark plus-btn"
                                        id="dropdown-basic"
                                      >
                                        Add manually
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <div className="py-2 px-3">
                                          <div className="d-flex mb-3">
                                            <div className="col">
                                              <Form.Label htmlFor="inputValue">
                                                Key
                                              </Form.Label>
                                              <Form.Control
                                                type="text"
                                                id="inputValue"
                                                aria-describedby="passwordHelpBlock"
                                                className="rounded-end-0 border-end-0"
                                                onChange={(e) => {
                                                  setdropkey(e.target.value);
                                                }}
                                                value={dropkey}
                                              />
                                            </div>
                                            <div className="col">
                                              <Form.Label htmlFor="inputKey">
                                                Value
                                              </Form.Label>
                                              <Form.Control
                                                type="text"
                                                id="inputKey"
                                                aria-describedby="passwordHelpBlock"
                                                className="rounded-start-0"
                                                onChange={(e) => {
                                                  setdropval(e.target.value);
                                                }}
                                                value={dropval}
                                              />
                                            </div>

                                          </div>
                                          <div className="gap-4">
                                            <Button
                                              variant="gray-light me-2"
                                              onClick={(e) => {
                                                setdropkey("");
                                                setdropval("");
                                              }}
                                            >
                                              {t("common.button.cancel")}
                                            </Button>

                                            <Button
                                              variant="dark"
                                              onClick={handleSavDropsetcalulateOthers}
                                            >
                                              Save
                                            </Button>
                                          </div>
                                        </div>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div> :
                        <textarea
                          className="form-control"
                          id="placeholderText"
                          rows="2"
                          onChange={(e) => {
                            setcalulateOtherVal(e.target.value);
                          }}
                          value={calulateOtherVal}
                        ></textarea>}
                    </>
                  }
                </>
              )}
            </Tab>
          </Tabs>
          <div className="mt-auto d-grid gap-2">
            <Button variant="dark" onClick={handleSaveSetting}>
              <i className="bx bx-save bx-sm align-middle"></i> Save Setting
            </Button>
            <Button variant="gray-light" onClick={() => setGlbflag(true)}><i className="bx bx-globe bx-sm align-middle"></i> Save as Global Field</Button>
          </div>
        </div>
        {videoRecorderModal && (
          <VideoRecorder
            show={videoRecorderModal}
            toggle={toggleVideoRecorderModal}
            handleSave={handleUploadVideo}
          />
        )}
      </div>
    </>
  );
};

export default FormRightbar;
